import { useAuth } from "../context/AuthContext";
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DropDownTrustSelection from "./DropDownTrustSelection";
import { ButtonModalFormSaveClose } from "./ButtonModalSelection";

export const AddEditFacility = ({
  onComplete,
  close,
  selectedTrust,
  facility,
}) => {
  const { authAxios } = useAuth();
  const [address, setAddress] = useState(facility ? facility?.address : "");
  const [email, setEmail] = useState(facility ? facility?.email : "");
  const [name, setName] = useState(facility ? facility?.name : "");
  const [phone, setPhone] = useState(facility ? facility?.phone : "");
  const [trust, setTrust] = useState(facility ? facility?.trust : null);
  const [nameError, setNameError] = useState("");
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const [facilities, setFacilities] = useState([]);

  useEffect(() => {
    getFacilities();
  }, []);

  useEffect(() => {
    if (trust === null) {
      setTrust(selectedTrust);
    }
  }, [selectedTrust, trust]);

  const phoneHandler = (e) => {
    let enteredPhone = e.target.value;
    setPhone(() => enteredPhone);
    let regex =
      /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/g;

    console.log(
      "entered phone number regex match: ",
      !enteredPhone.match(regex),
    );
    if (!enteredPhone.match(regex)) {
      setPhoneError("Invalid phone number");
    } else {
      setPhoneError("");
    }
  };

  const getFacilities = async () => {
    let isMounted = true;
    try {
      var params = {};
      if (trust !== null && trust !== undefined) {
        params["trust_id"] = null;
      }
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().post(
        "/api/backoffice/facilities/all",
        null,
        config,
      );
      if (isMounted) {
        setFacilities(response.data);
      }
    } catch (error) {
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
    return () => (isMounted = false);
  };

  const onSave = async (e) => {
    setSaveDisabled(true);
    e.preventDefault();
    let apiCall = "/api/backoffice/facilities/facility_new";
    let params = {
      trust_id: trust?.id,
    };
    if (facility) {
      apiCall = "/api/backoffice/facilities/facility_edit";
      params = {
        trust_id: trust?.id,
        facility_id: facility?.id,
      };
    }
    try {
      const payload = {
        name: name,
        address: address,
        email: email,
        phone: phone,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().post(apiCall, payload, config);
      onComplete(response.data);
    } catch (err) {
      console.log("Error:");
      console.log(err);
    }
    return () => setSaveDisabled(false);
  };

  const nameHandler = (e) => {
    let enteredName = e.target.value;
    setNameError("");
    for (let f of facilities) {
      let isCurrentTrust = trust?.id === f?.trust?.id;
      let isNameMatch =
        enteredName.toLowerCase() === f.name.trim().toLowerCase();
      if (isCurrentTrust && isNameMatch) {
        setNameError(`This facility already exists for ${trust?.name}`);
        break;
      }
    }
    setName(enteredName);
  };

  const emailHandler = (e) => {
    setEmail(e.target.value);
  };

  const addressHandler = (e) => {
    setAddress(e.target.value);
  };

  return (
    <Form onSubmit={onSave}>
      <Form.Group className="mb-3">
        <Row>
          <Col xs={12}>
            <Form.Label>Facility Name</Form.Label>
          </Col>
          <Col xs={12}>
            <Form.Control
              type="text"
              value={name}
              onChange={nameHandler}
              isValid={name && nameError === ""}
              isInvalid={name && nameError !== ""}
              required
            />
            <Form.Control.Feedback type="invalid">
              {nameError}
            </Form.Control.Feedback>
          </Col>
        </Row>
      </Form.Group>

      <Form.Group className="mb-3">
        <Row>
          <Col xs={12}>
            <Form.Label>Facility Address</Form.Label>
          </Col>
          <Col xs={12}>
            <Form.Control
              type="text"
              value={address}
              onChange={addressHandler}
              required
            />
          </Col>
        </Row>
      </Form.Group>

      <Form.Group className="mb-3">
        <Row>
          <Col xs={12}>
            <Form.Label>Email</Form.Label>
          </Col>
          <Col xs={12}>
            <Form.Control
              type="email"
              value={email}
              onChange={emailHandler}
              required
            />
          </Col>
        </Row>
      </Form.Group>

      <Form.Group className="mb-3">
        <Row>
          <Col xs={12}>
            <Form.Label>Phone Number</Form.Label>
          </Col>
          <Col xs={12}>
            <Form.Control
              type="text"
              value={phone}
              onChange={phoneHandler}
              isValid={phone && phoneError === ""}
              isInvalid={phone && phoneError !== ""}
            />
            <Form.Control.Feedback type={"invalid"}>
              {phoneError}
            </Form.Control.Feedback>
          </Col>
        </Row>
      </Form.Group>

      <Form.Group className="mb-3">
        <Row>
          <Col xs={12}>
            <Form.Label>Trust</Form.Label>
          </Col>
          <Col xs={12}>
            <Form.Control
              as={DropDownTrustSelection}
              defaultValue={selectedTrust}
              onSelected={setTrust}
              disabled={facility !== null}
            />
          </Col>
        </Row>
      </Form.Group>

      <ButtonModalFormSaveClose
        close={close}
        formSave={onSave}
        saveName={"Save"}
        loading={saveDisabled}
      />
    </Form>
  );
};
